import { gql } from "apollo-boost"

export const CREATE_INDICATORS = gql`
  mutation createIndicators ($indicators: [CreateIndicatorInput!]!) {
    createIndicators(indicators: $indicators) {
      id
    }
  }
`
